// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
  .search-icon {
    fill: #586671;
    height: 100%;
  }
`, "",{"version":3,"sources":["webpack://./src/components/icons/search-icon.css"],"names":[],"mappings":";EACE;IACE,aAAa;IACb,YAAY;EACd","sourcesContent":["\n  .search-icon {\n    fill: #586671;\n    height: 100%;\n  }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
